module.exports = __webpack_public_path__ + "img/LAO.e6331fa0.svg";